import { type FunctionComponent } from "react";


type FormHeaderProps = {
  title?: string;
};

export const FormHeader: FunctionComponent<FormHeaderProps> = ({ title }) => {
  return (
    <>
        <title>{title}</title>
      <header>
        <h1 className="form-header mt-8">{title}</h1>
      </header>
    </>
  );
};
